import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import {userSelectors} from 'features/userSlice';
import {favoriteListsActions, favoriteListsSelectors} from 'features/favoriteListsSlice';
import {ReactComponent as HeartIcon} from 'components/icons/heart.svg';
import {ReactComponent as HeartFullIcon} from 'components/icons/heart-full.svg';
import FavoriteListsPopover from './FavoriteListsPopover';
import LoadingBottle from './LoadingBottle';

const FavoritesHeart = ({
  wineId,
  wineName,
}) => {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const soldTo = useSelector(userSelectors.soldTo);
  const isFavorite = useSelector(favoriteListsSelectors.isWineFavorited(wineId));
  const favoriteListsRequest = useSelector(favoriteListsSelectors.favoriteListsRequest);

  useEffect(() => {
    if (soldTo != null && favoriteListsRequest.status === 'idle') {
      dispatch(favoriteListsActions.fetchFavoriteLists({soldTo: soldTo}));
    }
  }, [soldTo, favoriteListsRequest.status]);

  const isLoading = favoriteListsRequest.status === 'idle' || favoriteListsRequest.status === 'loading';

  return (
    <>
      <div className="cursor-pointer" style={{color: '#EA0055', height: '24px'}}
        onClick={(ev) => {
          ev.preventDefault();
          if (!isLoading) {
            setOpen(true);
          }
        }}>
        {isLoading ?
          <LoadingBottle/>
          : isFavorite ?
            <HeartFullIcon/>
            :
            <HeartIcon/>
        }
      </div>
      <FavoriteListsPopover
        wineId={wineId}
        wineName={wineName}
        open={open}
        setOpen={setOpen}
      />
    </>
  );
};

FavoritesHeart.propTypes = {
  wineId: PropTypes.string,
  wineName: PropTypes.string,
};

export default FavoritesHeart;
